import api from 'api'

export const updateStep = async (formId, id, payload) => {
  const { data } = await api.put(`/form/${formId}/step/${id}`, payload)

  return data
}
